import React from 'react';
import CustomerForm from '../components/CustomerForm';
import {renderFragment} from '../helpers/react-helpers'

export default function (props: any) {
    renderFragment(<CustomerForm {...props}/>, '#page-content')
}
